import { render, staticRenderFns } from "./TechInfoVariant.vue?vue&type=template&id=12af7158&"
import script from "./TechInfoVariant.vue?vue&type=script&lang=js&"
export * from "./TechInfoVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports